import { render } from "./MonacoEditorCustom.vue?vue&type=template&id=e494cc30"
import script from "./MonacoEditorCustom.vue?vue&type=script&lang=js"
export * from "./MonacoEditorCustom.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__